import store from '@/store';

export default (to, from, next) => {

    const is_postpay_mobile = store.getters.is_account_postpay && !store.getters.is_account_postpay_fwa

    return {
        allow: is_postpay_mobile,
        redirect: { name: 'not-found' },
    }

};